export var BulkChargeTypes = {
  FLAT: 1,
  UNIT: 2
};